/**
 * 「해외 접속 차단」 모드(SPEC-SENDCERT-001 D-142) 화면 규칙.
 * 모드 값은 inapi 와 같다: off(끔)·log(기록만)·enforce(차단). 운영 페이지에서 저장한 값(db)이 없으면 서버 설정 파일 값(env).
 * Vue·axios 를 들이지 않는 순수 모듈이라 node --test 로 시험한다(`__tests__/geoMode.test.mjs`).
 */

export const GEO_MODES = [
  { value: "off", label: "끔", color: "default", desc: "해외 접속을 막지 않고, 따로 기록하지도 않습니다." },
  { value: "log", label: "기록만", color: "blue", desc: "해외 접속을 막지 않고, 막혔을 요청만 기록합니다." },
  { value: "enforce", label: "차단", color: "red", desc: "해외 IP 접속을 막습니다(허용 IP·계정별 예외 제외)." },
];

const modeOf = (mode) => GEO_MODES.find((m) => m.value === mode);

/** 모드 이름. 모르는 값은 그대로, 없으면 "-" */
export const geoModeLabel = (mode) => (modeOf(mode) || {}).label || mode || "-";

export const GEO_MODE_SOURCE_LABEL = {
  db: "운영 페이지에서 설정",
  env: "서버 설정 파일 값",
};

export const ENFORCE_WARNING =
  "해외 IP 에서는 로그인부터 모든 이용이 막힙니다. 서버끼리 주고받는 요청의 IP 가 허용 목록에 없으면 기능이 멈출 수 있습니다.";
export const RELAX_WARNING = "해외 접속이 막히지 않습니다(기록만이면 기록은 남음).";

/** 바꾸기 확인창 경고 문구 */
export const geoModeConfirmText = (mode) => (mode === "enforce" ? ENFORCE_WARNING : RELAX_WARNING);

/**
 * 바꾸기 전 검사. 괜찮으면 "", 아니면 안내 문구.
 * 설정 파일 값을 쓰는 중(source env)이면 같은 모드라도 저장할 수 있다 — 운영 페이지 값으로 고정하는 뜻이라서
 */
export const geoModeChangeError = (current, next, reason) => {
  if (!modeOf(next)) return "바꿀 모드를 고르세요.";
  if (current && current.source === "db" && current.mode === next) return "지금과 같은 모드입니다.";
  if (!String(reason ?? "").trim()) return "사유를 입력하세요.";
  return "";
};

/** 이력 「이전 → 이후」 칸 */
export const geoModeTransition = (d) =>
  d ? `${geoModeLabel(d.before)} → ${geoModeLabel(d.after)}` : "-";
